import React, {Component, forwardRef} from 'react'
import FJDropDown from 'fj-components/FJDropDown'
import FJPaymentLimitTip from './FJPaymentLimitTip.react'
import classNames from 'classnames'
import Style from './FJExportPayment.module.less'
import FJUpgradeButton from "../../../common/component/FJUpgradeButton";

const ForwardTrigger = forwardRef((props, ref) => {
  let {active, onRenderIcon} = props;
  return (
    <div ref={ref} className={classNames(Style.question__container, {[Style.active]: active})}>
      {onRenderIcon()}
    </div>
  );
});

class FJExportPayment extends Component {

  render() {

    let {downloadLimitText, upgradeText, overLimitContents} = this.props;
    let {onDownloadWithWaterMark, onUpgrade, onRenderIcon} = this.props;
    return (
      <div className={Style.box}>
        <FJUpgradeButton onClick={onUpgrade} className={Style.upgrade_btn} text={upgradeText}/>
        <div className={Style.info}>
          <span onClick={onDownloadWithWaterMark}
                className={Style.download__wm__title}>{downloadLimitText}</span>
          <FJDropDown overlay={
            <FJPaymentLimitTip limits={overLimitContents}/>
          }
                      placement='rightBottom'
                      isTopLayer
                      hasArrow
                      propsLeft={6}
                      propsTop={12}
                      canTriggerActive
                      trigger='hover'
          >
            <ForwardTrigger onRenderIcon={onRenderIcon}/>
          </FJDropDown>
        </div>
      </div>
    );
  }
}

export default FJExportPayment;
